module.exports = __webpack_public_path__ + "img/popularize02.3f941a28.png";